/* hub-affiliate-ref.js — ATHLO+ affiliate/creator LINK capture.
 *
 * A creator's link is  athlo.sg/?ref=<handle>.  On any page that carries ?ref=:
 *
 *   FUNCTIONAL (fires immediately, no consent needed):
 *     - stamps the ref + a click id into THIS visitor's Shopify CART as note attributes, so a paid
 *       order credits the creator even without the code (loyalty handleAffiliateOnOrder reads
 *       affiliate_ref / affiliate_cid). First-party, tied to the shopping session the visitor started
 *       by following the creator's link -- it is the mechanism that actually pays the affiliate.
 *
 *   NON-ESSENTIAL (deferred until the visitor ACCEPTS analytics consent -- PDPA: no non-essential
 *   data before acceptance):
 *     - the click-analytics beacon to the loyalty function (one click row);
 *     - the durable cross-visit identifiers in localStorage (athlo_cid / athlo_ref);
 *     - auto-applying the creator's discount code via /discount/<code>.
 *   Declining costs the creator NOTHING -- the cart stamp above already carries attribution. If
 *   consent was granted (this or a past visit) the tracked half runs now; otherwise it waits for the
 *   consent banner's 'athlo:consent' event, and on decline it simply never runs.
 *
 * Removable as a unit: this asset + its one <script> line in theme.liquid. Fail-safe throughout. ASCII-only.
 */
(function () {
  'use strict';
  try {
    var params = new URLSearchParams(window.location.search);
    var ref = (params.get('ref') || '').trim().toLowerCase();
    if (!ref || !/^[a-z0-9-]{2,40}$/.test(ref)) return;

    var ENDPOINT = 'https://vjuhcxzmtzylzorqjtsc.supabase.co/functions/v1/loyalty?action=affiliate-click';

    // A stable-per-visitor click id shared by the cart stamp and the (later) click beacon. Reuse a
    // persisted id if the visitor consented on a past visit; otherwise mint one IN MEMORY only -- it
    // is not written to localStorage until consent is granted (see runTracked).
    var clickId = '';
    try { clickId = localStorage.getItem('athlo_cid') || ''; } catch (e) {}
    if (!clickId) clickId = 'c_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);

    // The address to return to once the code is applied: this page minus ?ref (no loop, clean bar).
    params.delete('ref');
    var q = params.toString();
    var cleanPath = window.location.pathname + (q ? '?' + q : '');

    function tidy() {
      try { if (window.history && history.replaceState) history.replaceState(null, '', cleanPath); } catch (e) {}
    }

    // FUNCTIONAL: stamp the referrer onto the cart immediately. Best-effort; persists as order
    // note_attributes the webhook reads. Keep a handle so the tracked half can chain AFTER it lands.
    var stamp = fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ attributes: { affiliate_ref: ref, affiliate_cid: clickId } })
    }).catch(function () {});

    // NON-ESSENTIAL: persist the ids, beacon the click, then apply the discount. Consent-gated.
    var fired = false;
    function runTracked() {
      if (fired) return; fired = true;
      try { localStorage.setItem('athlo_cid', clickId); localStorage.setItem('athlo_ref', ref); } catch (e) {}
      var alreadyApplied = false;
      try { alreadyApplied = localStorage.getItem('athlo_ref_applied') === ref; } catch (e) {}
      stamp.then(function () {
        return fetch(ENDPOINT, {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({ handle: ref, cid: clickId, path: window.location.pathname })
        });
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.code && !alreadyApplied) {
            try { localStorage.setItem('athlo_ref_applied', ref); } catch (e) {}
            window.location.replace('/discount/' + encodeURIComponent(d.code) + '?redirect=' + encodeURIComponent(cleanPath));
          } else {
            tidy();
          }
        })
        .catch(tidy);
    }

    // Run now if consent was already granted; otherwise clean the URL and wait for the banner choice.
    var consentOk = false;
    try { var c = JSON.parse(localStorage.getItem('athlo:consent') || 'null'); consentOk = !!(c && c.analytics); } catch (e) {}
    if (consentOk) {
      runTracked();
    } else {
      tidy();
      document.addEventListener('athlo:consent', function (ev) {
        if (ev && ev.detail && ev.detail.analytics) runTracked();
      }, { once: true });
    }
  } catch (e) { /* never let a referral break the page */ }
})();
